// The sandbox's Agents page (D105): no grants, tokens or audit log of its own, but a signed-in
// person may try the CLI, MCP or skills on it with a sandbox token the console mints for their
// session: read-only, for the sandbox's project, until it expires. Shown once, here.
import { useState } from 'react'
import { CodeBlock } from '../components/CodeBlock'
import { Section } from '../components/d'
import { useI18n } from '../i18n'
import { sandboxErrorKey } from '../lib/openSandbox'
import { mintSandboxToken, type SandboxToken } from '../sandbox'
import { MCP_URL } from './Agents'

export function SandboxAgents() {
  const { t, date } = useI18n()
  const [made, setMade] = useState<SandboxToken>()
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>()
  async function mint() {
    setBusy(true)
    setError(undefined)
    try {
      setMade(await mintSandboxToken())
    } catch (e) {
      setError(e)
    } finally {
      setBusy(false)
    }
  }
  return (
    <main id="main">
      <div className="head-text">
        <div className="k">{t('sandbox.kicker')}</div>
        <h1 className="h1">{t('sandbox.agents.title')}</h1>
        <p className="lede">{t('sandbox.agents.lede')}</p>
      </div>
      <Section title={t('sandbox.agents.token')}>
        <div className="pb stack">
          {made ? (
            <>
              <p className="notice ok" role="status">
                {t('sandbox.agents.made', {
                  date: date(made.expires_at, { dateStyle: 'medium', timeStyle: 'short' }),
                })}
              </p>
              <CodeBlock
                label={t('sandbox.agents.cli')}
                lines={[
                  `export APSIO_TOKEN=${made.token}`,
                  `export APSIO_PROJECT=${made.project_id}`,
                  'apsio issues',
                ]}
              />
              <CodeBlock
                label={t('sandbox.agents.mcp')}
                lines={[
                  `claude mcp add --transport http apsio-sandbox ${MCP_URL} \\`,
                  `  --header "Authorization: Bearer ${made.token}"`,
                ]}
              />
              <button
                type="button"
                className="btn small"
                style={{ justifySelf: 'start' }}
                onClick={() => setMade(undefined)}
              >
                {t('agents.tokens.done')}
              </button>
            </>
          ) : (
            <button
              type="button"
              className="btn solid"
              style={{ justifySelf: 'start' }}
              disabled={busy}
              onClick={mint}
            >
              {t('sandbox.agents.get')}
            </button>
          )}
          {error ? (
            <p role="alert" className="notice error">
              {t(sandboxErrorKey(error))}
            </p>
          ) : null}
        </div>
      </Section>
    </main>
  )
}
